import { createFileRoute } from '@tanstack/react-router';
import { AssignedToMePage } from '@/features/my-tasks/pages';

export const Route = createFileRoute('/w/$workspaceId/my/assigned')({ component: AssignedToMePage });
